import shareState from '../utils/shareState.js'
const getState = () => {
  return new Promise((resolve, reject) => {
    let t = 0
    const tm = setInterval(() => {
      if (shareState.state.styleId !== 0 && shareState.state.genreType !== 0) {
        clearInterval(tm)
        resolve(shareState.state)
      }
      t = t + 100
      if (t > 30000) {
        clearInterval(tm)
        // Message.error('获取styleId失败，用时：' + t / 1000 + '秒')
        reject(t)
      }
    }, 100)
  })
}
export default getState
